import * as React from 'react';
import {styled} from '@mui/material/styles';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import PublicIcon from '@mui/icons-material/Public';
import SchoolIcon from '@mui/icons-material/School';
import ComputerIcon from '@mui/icons-material/Computer';

import {useNavigate} from "react-router-dom";

const TextButton = styled(ButtonBase)(({theme}) => ({
    position: 'relative',
    height: 48,
    mb: 2,

    [theme.breakpoints.down('md')]: {
        width: '100% !important', // Overrides inline-style
        marginBottom: '.2rem'
    },
    '&:hover, &.Mui-focusVisible': {
        zIndex: 1,
        '& .MuiImageBackdrop-root': {
            backgroundColor: theme.palette.secondary.dark,
        },
    },
}));

const Text = styled('span')(({theme}) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.secondary.contrastText,
    textTransform: 'uppercase',
}));

const TextBackdrop = styled('span')(({theme}) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.secondary.light,
    transition: theme.transitions.create('all', {
        duration: theme.transitions.duration.standard,
    }),
}));

export const ButtonBases = () => {
    const navigate = useNavigate();

    const items = [
        {
            image: PublicIcon,
            title: "Découvrir",
            url: "/presentation",
        },
        {
            image: SchoolIcon,
            title: "Se former",
            url: "/education",
        },
        {
            image: ComputerIcon,
            title: "S'inscrire",
            url: "/enroll",
        },
    ];

    return (
        <Box sx={{display: 'flex', flexWrap: 'wrap', minWidth: 300, width: '100%'}}>
            {items.map((item) => (
                <TextButton
                    onClick={() => navigate(item.url)}
                    focusRipple
                    key={item.title}
                    style={{flexGrow: 1}}
                >
                    <TextBackdrop className="MuiImageBackdrop-root"/>
                    <Text>
                        <Typography
                            component="span"
                            variant="subtitle1"
                            color="inherit"
                            fontWeight="500"
                            sx={{
                                position: 'relative',
                                p: 4,
                                pt: 2,
                                pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
                            }}
                        >
                            {item.title}
                        </Typography>
                    </Text>
                </TextButton>
            ))}
        </Box>
    );
}
